import { render } from "./TrialExpiredModal.vue?vue&type=template&id=25ebe099"
import script from "./TrialExpiredModal.vue?vue&type=script&lang=js"
export * from "./TrialExpiredModal.vue?vue&type=script&lang=js"

import "./TrialExpiredModal.vue?vue&type=style&index=0&id=25ebe099&lang=scss"

import exportComponent from "/Users/andersnielsen/Sites/demo-leverandoroverblik/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__